import { LoggerService } from "./shared/services/logger.service";
import { ErrorHandler, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private loggerService: LoggerService) { }
  handleError(error: any) {
    const errorMessage = [
      'Unhandled exception occur from angular app.',
      `URL: ${window.location.href}`,
      `Error: ${JSON.stringify(error)}`,
      `Stack Trace: ${error?.stack ?? 'N/A'}`
    ].join('\n- ');

    this.loggerService.logError(errorMessage);
  }
}
